/**
 * @generated SignedSource<<fe05b6883822657a53ca6bc13d9e97ed>>
 * @relayHash ec5d9e8e83cac31fda570bc02ce0eee8
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID ec5d9e8e83cac31fda570bc02ce0eee8

import { ConcreteRequest } from 'relay-runtime';
export type De_deleteReferralLetterInput = {
  id: string;
};
export type useDeDeleteReferralMutation$variables = {
  input: De_deleteReferralLetterInput;
};
export type useDeDeleteReferralMutation$data = {
  readonly de_deleteReferralLetter: {
    readonly de_ReferralLetter: {
      readonly id: string;
    } | null;
  };
};
export type useDeDeleteReferralMutation = {
  response: useDeDeleteReferralMutation$data;
  variables: useDeDeleteReferralMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useDeDeleteReferralMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "De_deleteReferralLetterPayload",
        "kind": "LinkedField",
        "name": "de_deleteReferralLetter",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "de_ReferralLetter",
            "kind": "LinkedField",
            "name": "de_ReferralLetter",
            "plural": false,
            "selections": [
              (v2/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "useDeDeleteReferralMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "De_deleteReferralLetterPayload",
        "kind": "LinkedField",
        "name": "de_deleteReferralLetter",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "de_ReferralLetter",
            "kind": "LinkedField",
            "name": "de_ReferralLetter",
            "plural": false,
            "selections": [
              (v2/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "filters": null,
                "handle": "deleteRecord",
                "key": "",
                "kind": "ScalarHandle",
                "name": "id"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "ec5d9e8e83cac31fda570bc02ce0eee8",
    "metadata": {},
    "name": "useDeDeleteReferralMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "f6429b51306644a00f69c816d8b1b15e";

export default node;
